import React from "react";
import Pagination from "react-responsive-pagination";

const getNumberOfPages = (rowCount, rowsPerPage) => {
  const pages = Math.ceil(rowCount / rowsPerPage);
  return pages > 0 ? pages : 1;
};

const Paginator = props => {
  const {rowsPerPage, rowCount, onChangePage, currentPage} = props;

  const pages = getNumberOfPages(rowCount, rowsPerPage);

  return (
    <div className="d-flex mt-5 justify-content-end">
      <Pagination
        current={currentPage}
        total={pages}
        onPageChange={onChangePage}
      />
    </div>
  );
};

export default Paginator;
